import {Component, Input} from '@angular/core';

import {DetailField, DetailParams} from '../../../../shared';
import { ContactoDetailParams} from '../../../models';
import {CONTACTO_DETAIL_DEFAULT_FIELDS} from "../../../constants";

@Component({
  selector: 'app-contacto-detail',
  templateUrl: './contacto-detail.component.html',
  styleUrls: ['./contacto-detail.component.scss']
})
export class ContactoDetailComponent {
  fields: DetailField[] = [];
  detailParams: DetailParams = null;

  constructor() {
  }

  _params: ContactoDetailParams = null;

  @Input()
  set params(value: ContactoDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }
    this.fields = value.fields || CONTACTO_DETAIL_DEFAULT_FIELDS;
    const rows = this.fields.map(f => ({
      label: f.label,
      value: value.contacto[f.name]
    }));
    this.detailParams = {
      rows
    };
  }
}
